/* eslint-disable react/jsx-max-depth */ function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { createContext, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import routes from '../../routes/constants';
import text from '../../text';
import { pickBy, values } from 'lodash';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { profileSelectors } from '../../redux/selectors/profile';
import { isJobPayable } from '../../utilities/job';
import { isMembershipPriceId } from '../../utilities/membership';
import { isRouteIncluded } from '../../utilities/routes';
import { isStaff, isUserGovernment, isUserUnderTrial } from '../../utilities/user';
var WIZARD_KEYS = {
    order: 'order',
    membership: 'membership'
};
export var PaymentContext = /*#__PURE__*/ createContext(null);
var PaymentProvider = function(param) {
    var children = param.children, job = param.job;
    var _useState = _sliced_to_array(useState(null), 2), activeWizardStep = _useState[0], setActiveWizardStep = _useState[1];
    var _useState1 = _sliced_to_array(useState(text('estimate')), 2), cardHeading = _useState1[0], setCardHeading = _useState1[1];
    var location = useLocation();
    var isInOrderPage = isRouteIncluded([
        routes.payment.job()
    ]);
    var isInMembershipPage = isRouteIncluded([
        routes.user.membershipManagement
    ]);
    var _useSelector = useSelector(function(state) {
        return {
            currentUser: state.profileReducer.userProfile,
            membershipPriceId: state.order.membershipPriceId
        };
    }), currentUser = _useSelector.currentUser, membershipPriceId = _useSelector.membershipPriceId;
    var hasValidMembership = useSelector(profileSelectors.hasValidMembership);
    var wizardStepsHeading = useMemo(function() {
        var _obj;
        return _obj = {}, _define_property(_obj, WIZARD_KEYS.order, [
            {
                text: text('estimate'),
                filter: function() {
                    return !process.env.DISABLE_STRIPE && !isUserGovernment(currentUser) && !isStaff(currentUser.role) && (!hasValidMembership || isUserUnderTrial(currentUser));
                }
            },
            {
                text: text('estimate')
            },
            {
                text: text('quote'),
                filter: function() {
                    return !isStaff(currentUser.role) && isJobPayable(job) || isMembershipPriceId(membershipPriceId);
                }
            },
            {
                text: text('invoice')
            }
        ]), _define_property(_obj, WIZARD_KEYS.membership, [
            {
                text: text('estimate')
            },
            {
                text: text('quote')
            },
            {
                text: text('invoice')
            }
        ]), _obj;
    }, [
        currentUser,
        hasValidMembership,
        membershipPriceId,
        job
    ]);
    var wizardKeys = useMemo(function() {
        return [
            {
                key: WIZARD_KEYS.order,
                isActive: isInOrderPage(location.pathname)
            },
            {
                key: WIZARD_KEYS.membership,
                isActive: isInMembershipPage(location.pathname)
            }
        ];
    }, [
        isInMembershipPage,
        isInOrderPage,
        location.pathname
    ]);
    var getActiveRouteKey = useMemo(function() {
        if (!activeWizardStep) {
            return text('estimate');
        }
        return wizardKeys.find(function(wk) {
            return !!wk.isActive;
        });
    }, [
        activeWizardStep,
        wizardKeys
    ]);
    var handleSetCardHeading = useCallback(function() {
        if (activeWizardStep) {
            var _filteredWizardStepsHeading_;
            var step = activeWizardStep.step, wizard = activeWizardStep.wizard;
            var filteredWizardStepsHeading = values(pickBy(wizardStepsHeading[wizard], function(step) {
                return !step.filter || step.filter();
            }));
            // (step - 1) if wizard = order coz `Cart` step is index 0 so step is starting at 1
            var stepIndex = wizard === WIZARD_KEYS.membership ? step : step - 1;
            setCardHeading((filteredWizardStepsHeading === null || filteredWizardStepsHeading === void 0 ? void 0 : (_filteredWizardStepsHeading_ = filteredWizardStepsHeading["".concat(stepIndex)]) === null || _filteredWizardStepsHeading_ === void 0 ? void 0 : _filteredWizardStepsHeading_.text) || text('estimate'));
        }
    }, [
        activeWizardStep,
        wizardStepsHeading
    ]);
    var handleSetWizardStep = useCallback(function(step) {
        setActiveWizardStep({
            step: step,
            wizard: getActiveRouteKey === null || getActiveRouteKey === void 0 ? void 0 : getActiveRouteKey.key
        });
    }, [
        getActiveRouteKey === null || getActiveRouteKey === void 0 ? void 0 : getActiveRouteKey.key
    ]);
    var memoizedState = useMemo(function() {
        var membershipStepper = [
            text('member'),
            text('paymentMethod'),
            text('confirmation')
        ];
        return {
            activeWizardStep: activeWizardStep,
            cardHeading: cardHeading,
            membershipStepper: membershipStepper
        };
    }, [
        activeWizardStep,
        cardHeading
    ]);
    var memoizedActions = useMemo(function() {
        return {
            handleSetWizardStep: handleSetWizardStep
        };
    }, [
        handleSetWizardStep
    ]);
    useEffect(function() {
        handleSetCardHeading();
    }, [
        handleSetCardHeading
    ]);
    // ref to expose functions from Stepper component
    var wizzardFunctions = useRef({});
    return /*#__PURE__*/ React.createElement(PaymentContext.Provider, {
        value: {
            states: memoizedState,
            actions: memoizedActions,
            refs: {
                wizzardFunctions: wizzardFunctions
            }
        }
    }, children);
};
PaymentProvider.propTypes = {
    children: PropTypes.element
};
export default PaymentProvider;
